import { CollectionConstant } from "presentation/constant/Collection/CollectionConstant";
import { useCollectionVM } from "presentation/hook/Collection/useCollectionVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useCollectionTracked } from "presentation/store/Collection/CollectionProvider";
import { formatNumber } from "presentation/utils/numberUtil";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useMemo } from "react";
import { FieldType, IFieldValue } from "veronica-ui-component/dist/component/core";
import { Sidebarheader } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const CollectionHeaderBar: React.FC = () => {
    const SCREEN_CONSTANT = CollectionConstant;
    const [collectionState] = useCollectionTracked();
    const collectionVM = useCollectionVM();
    const [anaInfoState] = useANAInfoTracked();
    const { operatingUnit } = anaInfoState;
    const { draftInvoiceNos, totalInvAmt, observation, isEditingHdr, currentRow } = collectionState;
    const memoDraftInvoiceNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: (operatingUnit !== 'SAPT' && operatingUnit !== 'KICT') ? "200px" : "600px", marginTop: "15px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={draftInvoiceNos ?? ''}
                fieldValue={draftInvoiceNos}
                fieldLabel={SCREEN_CONSTANT.DRAFT_INVOICE_NO}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'draftInvoiceNos'}
                maxLength={12}
                options={[]}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    collectionVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [draftInvoiceNos, SCREEN_CONSTANT.DRAFT_INVOICE_NO, collectionVM, operatingUnit])

    const memoTotalAmount = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "200px", marginTop: "15px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={formatNumber(totalInvAmt ?? 0, 2)?.toString() ?? ''}
                fieldValue={totalInvAmt}
                fieldLabel={SCREEN_CONSTANT.TOTAL_AMOUNT}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'totalInvAmt'}
                maxLength={60}
                options={[]}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    collectionVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [totalInvAmt, SCREEN_CONSTANT.TOTAL_AMOUNT, collectionVM])

    const memoObservation = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "600px", marginTop: "15px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={isEditingHdr || currentRow.finalInvoiceNo}
                isShowOptional={true}
                readOnlyValue={observation ?? ''}
                fieldValue={observation}
                fieldLabel={SCREEN_CONSTANT.OBSERVATION}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'observation'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    collectionVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [observation, SCREEN_CONSTANT.OBSERVATION, collectionVM, isEditingHdr, currentRow.finalInvoiceNo])




    return <Sidebarheader style={{ width: '100%' }}>
        <CriteriaItemContainer>
            {memoDraftInvoiceNo}
            {memoTotalAmount}
            {(operatingUnit !== 'SAPT' && operatingUnit !== 'KICT') && memoObservation}
        </CriteriaItemContainer>
    </Sidebarheader>
}

export default memo(CollectionHeaderBar);